<template>
  <div>
    <!-- <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="setRow" style="float:right;margin:10px 15px 10px 0;"></el-button> -->
    <el-table border :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="BarCode" label="条码" />
      <el-table-column prop="WarehouseName" label="仓库" width="130">
      </el-table-column>
      <el-table-column prop="GoodsName" label="商品名称" width="130">
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="UnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量">
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="现存量" />
      <el-table-column prop="AvailableQuantity" label="可用量 " />
      <el-table-column prop="offer" label="报价" />
      <el-table-column prop="Discount" label="折扣%">
      </el-table-column>
      <el-table-column prop="Price" label="单价" />
      <el-table-column prop="TaxRate" label="税率/%">
      </el-table-column>
      <el-table-column prop="TaxAmount" label="税额" />
      <el-table-column prop="Amount" label="金额" />
      <el-table-column prop="Remark" label="备注" width="150px">
      </el-table-column>
      <!-- <el-table-column label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-link icon="el-icon-copy-document" style="margin-right:10px;" @click="copy(scope.row,scope.$index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click="del(scope.row,scope.$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column> -->
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from "@/components/sales/business/listDialog";
export default {
  props: {
    info: {},
  },
  components: {
    goodsDialog
  },
  data() {
    return {
      tableData: [],
      sApi: require("@/api/goods/goods").default,
      api: require("@/api/sale/stInDoc").default,
      wareApi: require("@/api/ba/warehouse").default,
      PriAdjustGoodsList: [],
      wareList: [],
      nowIndex: 0,
    };
  },
  beforeMount() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
    })
  },
  methods: {
    getData() {
      this.tableData = []
      this.api.getGoodsList({ id: this.info.DocId }).then((res) => {
        this.tableData = res.Data;
      });
    },
    setRow() {
      this.tableData.push({T: 0})
    },
    del(row,index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(!isNaN(row.T)&&row.T!==0) {
            row.T = 2
            this.tableDel.push(row)
          }
          this.tableData.splice(index,1)
          this.subTable()
        })
    },
    copy(row,index) {
        this.tableData.splice(index,0,{
          ...row
        })
        this.tableData[index].OrderGoodsId = 0
        this.tableData[index].T = 0
        this.subTable()
    },
    addGoods(row,index) {
      if(!row.WarehouseId) {
        this.$message.error("请先选择仓库")
        return
      }
      this.nowIndex = index
      let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({ Status: 1, WarehouseId: row.WarehouseId });
      });
    },
    setGoods(e) {
      let date = new Date()
      let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
      this.sApi.getGoodsPrice({ GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate }).then(res => {
        let goods = {
          T: 0,
          OrderGoodsId: 0,
          OrderId: this.info.OrderId || 0,
          BarCode: e.BarCode,
          GoodsName: e.GoodsName,
          GoodsId: e.GoodsId,
          Model: e.Model || "",
          UnitId: e.UnitId || 0,
          UnitName: e.MainUnitName || "",
          Quantity: 0,
          BatchNo: e.BatchNo || "",
          Offer: 0,
          Discount: 100,
          Price: e.WholesalePrice || 0,
          ExistQuantity: e.ExistQuantity || 0,
          AvailableQuantity: e.AvailableQuantity || 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: e.ReferenceCost || 0,
          GrossProfit: 0,
          Remark: e.Remark || "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: this.info.DocDate || today,
          WarehouseId: this.tableData[this.nowIndex].WarehouseId
        }
        if(res.Data != null) {
          goods.Offer = res.Data.VirtualPrice
        }
        this.tableData.splice(this.nowIndex,1,goods)
        // this.tableData.push(goods)
        // this.tableData[this.nowIndex] = goods
      })
    },
    setWare(row) {
      row.BarCode = ""
      row.GoodsName = ""
      row.Model = ""
      row.UnitName = ""
      row.UnitId = 0
      row.ExistQuantity = null
      row.AvailableQuantity = null
      row.Offer = null
      row.Discount = null
      row.Price = null
      row.TaxRate = null
      row.TaxAmount = null
      row.Amount = null
      row.Remark = ""
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity)
      this.count(row)
    },
    rateChange(row) {
      this.count(row)
    },
    disChange(row) {
      this.count(row)
    },
    count(row) {
      let price = row.Price?Number(row.Price):0
      let dis = row.Discount?Number(row.Discount):100
      let qua = row.Quantity?Number(row.Quantity):0
      let rate = row.TaxRate?Number(row.TaxRate):0
      let ref = row.ReferenceCost?Number(row.ReferenceCost):0
      if(row.T !== 0) {
        row.T = 1
      }
      row.Amount = (price * qua - (dis/100)).toFixed(2)
      row.TaxAmount = (row.Amount * rate / 100).toFixed(2) || 0
      row.GrossProfit = (row.Amount - (qua * ref)).toFixed(2)
      this.subTable()
    },
    subTable() {
      this.$emit("getList",this.tableData.concat(this.tableDel))
    },
  },
};
</script>

<style>
.el-link{
  font-size: 14px;
}
input::-webkit-outer-spin-button,

input::-webkit-inner-spin-button { -webkit-appearance: none; }

input[type="number"]{ -moz-appearance: textfield; }
</style>